import styled from 'styled-components';

export default styled.div`
    .sectionTitle {
        font-size: 25px;
        letter-spacing: 0.1em;

        color: ${(props) => props.theme.pageTitleText};
        margin-bottom: 10px;
        margin-top: 20px;
    }

    .downloadBtn {
        margin-top: 15px;
        margin-bottom: 15px;
        float: right;
    }

    .tableDiv {
        clear: right;
    }

    .actions {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: end;
    }
`;
